import React from "react";
import "./DestinationsSection.css";
import 
{
    vietnamImg, Dubai, lisbonImg, baliImg, NewYork, MexicoCity, chicagoImg, torontoImg

} from "../assets/destination";

const destinations = [
  { name: "Vietnam", image: vietnamImg },
  { name: "Dubai", image: Dubai },
  { name: "Lisbon", image: lisbonImg },
  { name: "Bali", image: baliImg },
  { name: "New York", image: NewYork },
  { name: "Mexico City", image: MexicoCity },
  { name: "Chicago", image: chicagoImg },
  { name: "Toronto", image: torontoImg },
];

// Continue with the rest of your component code here

// Tailwind CSS animation setup for infinite horizontal scroll
const DestinationsSection = () => {
  return (
    <div className="text-center py-10 sm:mx-3">
      <h2 className="text-3xl font-bold">
        Connect with others <span className="text-custom-red">worldwide</span>
      </h2>
      <p className="mt-2 text-gray-600">Spots we're hitting up soon 👇</p>

      {/* Scrolling container */}
      <div className="relative overflow-hidden mt-6">
        <div className="flex animate-scroll gap-4">
          {/* Duplicated rows for seamless infinite scrolling */}
          {[...destinations, ...destinations].map((destination, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-48 h-64 rounded-xl bg-cover bg-center text-white relative"
              style={{
                backgroundImage: `url(${destination.image})`,
              }}
            >
              <div className=" absolute bottom-4 left-4 bg-custom-red px-2 py-1 rounded-md text-white font-semibold text-sm">
                {destination.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DestinationsSection;
